export const ErrorActionTypes = {
  StoreError: 'ERROR_STORE_ERROR',
  ClearStoreError: 'ERROR_CLEAR_STORE_ERROR',
};
